<template>
  <layout
    titlePage="Adicionar dinheiro na Carteira"
    :route="{ name: 'carteira' }"
  >
    <div class="columns columns--full is-vcentered is-centered" v-if="loading">
      <base-reload :isReload="false" :dark="true" label="Carregando..." />
    </div>
    <section class="deposit-money" v-else>
      <div class="columns columns--full is-vcentered is-gapless">
        <div class="column is-two-fifths">
          <base-header-page
            :backgroundColor="'deposit-money__header'"
            class="c-base-header-page--full deposit-money__header-page"
          >
            <div class="deposit-money__content">
              <base-icon name="pix" width="145px" height="51px" />
              <h2>Adicione dinheiro na sua Carteira</h2>
              <p>
                Após a confirmação do pagamento o saldo da sua carteira será
                atualizado e você poderá utilizá-lo para comprar produtos para
                sua casa no Shopping Casar.com
              </p>
            </div>
          </base-header-page>
        </div>

        <div class="column deposit-money--max-width">
          <div class="deposit-money__body">
            <div class="deposit-money__body--header">
              <img :src="dataQrCode ? dataQrCode.qrCode : ''" />
              <p>
                Escaneie e pague o QR Code a seguir para adicionar dinheiro na
                sua Carteira Casar.com
              </p>
            </div>
            <div>
              <div class="deposit-money__body--steps">
                <ul>
                  <li
                    class="is-hidden-touch"
                    v-for="item in stepsDesktop"
                    :key="item"
                    v-html="item"
                  ></li>
                  <li
                    class="is-hidden-desktop"
                    v-for="item in stepsMobile"
                    :key="item"
                    v-html="item"
                  ></li>
                </ul>
              </div>

              <BaseCopyQrCode
                v-if="dataQrCode"
                class="is-hidden-desktop"
                :qrCode="dataQrCode.code"
              />

              <div class="deposit-money__info">
                <div class="deposit-money__info--qrcode">
                  <div class="img-qrcode is-hidden-touch">
                    <img
                      :src="dataQrCode ? dataQrCode.realQrCode : ''"
                      width="126"
                    />
                  </div>
                  <div class="deposit-money__info--qrcode-info">
                    <p class="deposit-money__info--data">
                      Efetue o pagamento até o dia
                      <span>{{ dataQrCode ? dataQrCode.due : '' }}</span>
                    </p>
                    <p class="deposit-money__info--value">
                      Valor:
                      <span>{{
                        dataQrCode ? dataQrCode.amount : 0 | currency
                      }}</span>
                    </p>
                  </div>
                </div>

                <p class="deposit-money__info--paragraph is-hidden-touch">
                  Se preferir, copie o código abaixo para realizar o pagamento.
                </p>

                <BaseCopyQrCode
                  v-if="dataQrCode"
                  class="is-hidden-touch"
                  :qrCode="dataQrCode.code"
                />
              </div>
            </div>
          </div>

          <div class="deposit-money__footer">
            <div class="deposit-money__footer--data">
              <base-icon name="logo-anel" width="50px" height="54px" />
              <div class="deposit-money__footer--casar">
                <p class="deposit-money__footer--title">
                  Dados do destinatário
                </p>
                <p>Casar.com Site de Casamento e Eventos LTDA</p>
                <p>CNPJ:08.713.XXX/0001-19</p>
              </div>
            </div>

            <base-button-bottom
              class="is-support is-big deposit-money__footer--button"
              type="button"
              @click.native="checkPayment(dataQrCode ? dataQrCode.id : '')"
            >
              Paguei com Pix
            </base-button-bottom>

            <p class="deposit-money__footer--paragraph">
              Você também receberá este QR Code para pagamento no seu e-mail de
              cadastro ;) Verifique em sua caixa de entrada ou SPAM.
            </p>
          </div>
        </div>
      </div>
    </section>
    <DepositNotFound ref="DepositNotFound" />
    <DepositError ref="DepositMoneyError" />
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import BaseHeaderPage from '@/components/BaseHeaderPage.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'

import BaseCopyQrCode from '@/components/BaseCopyQrCode.vue'
import DepositNotFound from '@/components/Wallet/DepositNotFound.vue'
import DepositError from '@/components/Wallet/ModalDepositMoneyError.vue'
import qrCode from '@/assets/img/qr-code.png'

import Payment from '@/lib/api/Payment'

import loadingViewMixin from '@/mixins/loadingViewMixin'

export default {
  mixins: [loadingViewMixin],

  components: {
    layout,
    BaseHeaderPage,
    BaseButtonBottom,
    BaseCopyQrCode,
    DepositNotFound,
    DepositError,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
  },

  data() {
    return {
      loading: false,
      formLoading: false,
      qrCode,
      code: null,
      stepsDesktop: [
        '1. Acesse a opção Pix no seu Internet Banking ou app de pagamentos;',
        '2. Escaneie o código a seguir ou copie o código de pagamento;',
        '3. Após o pagamento <strong>é só clicar no botão</strong><span> Paguei com Pix</span> no final desta tela;',
        '4. Após o pagamento, o valor será creditado em <strong>até 5 minutos</strong> na sua Carteira.',
      ],
      stepsMobile: [
        '1. Acesse a opção Pix no seu internet banking ou app de pagamentos;',
        '2. Escolha pagar com Pix;',
        '3. Copie e cole o seguinte código;',
        '4. Após o pagamento <strong>é só clicar no botão</strong><span> Paguei com Pix</span> no final desta tela;',
        ' 5. Após o pagamento, o valor será creditado em até <span>5 minutos</span> na sua Carteira.',
      ],
      dataQrCode: null,
    }
  },

  created() {
    this.dataQrCode = JSON.parse(localStorage.getItem('qrcode'))

    !this.dataQrCode && !this.$route.params.userPix
      ? this.$router.push({ path: `/carteira` })
      : ''
  },

  mounted() {
    if (!this.dataQrCode && this.$route.params.userPix) {
      /* Generate QRCode */
      const data = {
        payer_name: this.$route.params.userPix.name,
        payer_document: this.$route.params.userPix.cpf,
        source: 'wallet',
        source_id: this.logonToken.token_payload.wallet_id,
        amount: this.$route.params.value,
      }

      const paymentApi = new Payment(this.logonToken)

      this.loading = this.formLoading = true

      paymentApi
        .addInvoice(data)
        .then((response) => {
          if (response.data.data) {
            this.dataQrCode = {}

            this.dataQrCode.id = response.data.data.id
            this.dataQrCode.amount = response.data.data.amount
            this.dataQrCode.due = response.data.data.due
            this.dataQrCode.realQrCode =
              'data:image/png;base64, ' + response.data.data.qrcode
            this.dataQrCode.code = response.data.data.brcode

            localStorage.setItem('qrcode', JSON.stringify(this.dataQrCode))
          }
        })
        .catch(() => {
          this.$refs.DepositMoneyError.open()
        })
        .finally(() => (this.loading = this.formLoading = false))
    }
  },

  methods: {
    checkPayment(id) {
      /* Conditional that check if payment has been made */
      const paymentApi = new Payment(this.logonToken)

      this.loading = this.formLoading = true

      paymentApi
        .checkPayment(id)
        .then((response) => {
          if (response.data.data && response.data.data.status == 'credited') {
            this.$store.dispatch(
              'setCreditedPixAmount',
              this.$route.params.value
            )
            this.$router.push({ path: `/carteira` })
          } else {
            this.$refs.DepositNotFound.open()
          }
        })
        .catch(function () {
          this.$refs.DepositNotFound.open()
        })
        .finally(() => (this.loading = this.formLoading = false))
    },
  },
}
</script>

<style lang="scss">
.deposit-money {
  &__header {
    text-align: center;
    background: #3dafb0;

    @media (min-width: $tablet) {
      padding-left: 15%;
      text-align: left;
    }
  }

  &--max-width {
    margin: 30px 20px !important;

    @media (min-width: $tablet) {
      max-width: 547px;
      margin: 20px auto !important;
    }
  }

  .img-qrcode {
    width: 126px;
    height: 126px;
    background-color: #d7d6d6;
  }

  &__content {
    padding: 0 30px;

    @media (min-width: $tablet) {
      text-align: left;
      padding-right: 24px;
    }

    svg {
      margin-bottom: 24px;
    }

    h2 {
      font-family: Lato;
      font-size: 36px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.11;
      letter-spacing: normal;
      color: #fff;
      margin-bottom: 24px;

      @media (min-width: $tablet) {
        max-width: 315px;
      }
    }

    p {
      font-family: Lato;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.31;
      letter-spacing: normal;
      color: #fff;
    }
  }

  &__body {
    &--header {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-bottom: 32px;

      @media (min-width: $tablet) {
        flex-direction: row;
      }

      p {
        padding-top: 8px;
        font-family: Lato;
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.4;
        letter-spacing: normal;
        color: #5b6674;
        text-align: center;

        @media (min-width: $tablet) {
          padding-top: 0;
          padding-left: 24px;
          text-align: left;
        }
      }
    }

    &--steps {
      margin-bottom: 24px;

      li {
        strong {
          color: #5b6674;
        }
        span {
          font-weight: bold;
          color: $primary;
        }
      }
    }
  }

  &__info {
    .img-qrcode {
      margin-right: 48px;
    }

    &--qrcode {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 24px auto;

      @media (min-width: $tablet) {
        margin-bottom: 24px;
      }
    }

    &--qrcode-info {
      max-width: 182px;
      text-align: center;
    }

    &--data {
      border-radius: 8px;
      background-color: #f7fafb;
      padding: 11px 18px;
      margin-bottom: 16px;

      span {
        color: #3dafb0;
        font-weight: bold;
      }
    }

    &--value {
      font-size: 22px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.91;
      letter-spacing: normal;
      color: #5b6674;

      span {
        color: #3dafb0;
      }
    }

    &--paragraph {
      text-align: center;
      margin-bottom: 24px;
    }
  }

  &__footer {
    text-align: center;

    &--data {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 18px 12px 19px;
      border-radius: 8px;
      background-color: #f7fafb;
      margin-bottom: 24px;

      @media (min-width: $tablet) {
        max-width: 429px;
        margin: 0 auto;
        margin-bottom: 24px;
      }
    }

    &--casar {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      margin-left: 16px;

      p {
        color: #6e7983;
        text-align: left;
      }
    }

    &--title {
      font-weight: bold;
    }

    &--button {
      @media (min-width: $tablet) {
        margin-bottom: 24px;
      }
    }

    &--paragraph {
      color: #919191;
      font-size: 14px;
      margin-bottom: 70px;

      @media (min-width: $tablet) {
        margin-bottom: 24px;
      }
    }
  }
}
</style>
